module.exports = __webpack_public_path__ + "static/media/Affiliate-BG_mobile.ccccef16.webp";